import { render, staticRenderFns } from "./ultrasonic.vue?vue&type=template&id=561819c8"
import script from "./ultrasonic.vue?vue&type=script&lang=js"
export * from "./ultrasonic.vue?vue&type=script&lang=js"
import style0 from "./ultrasonic.vue?vue&type=style&index=0&id=561819c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports